import graphql from './graphql';

const query = /* GraphQL */ `
  query UserAchievement_passedFirstCourse($userId: ID!) {
    UserAchievement_passedFirstCourse(userId: $userId) {
      completed
      progress
    }
  }
`;

const UserAchievementUsedAppFirstTime = async ({ userId }) =>
  graphql(query, { userId })
    .then(
      // eslint-disable-next-line camelcase
      ({ UserAchievement_passedFirstCourse }) =>
        // eslint-disable-next-line camelcase
        UserAchievement_passedFirstCourse
    )
    .catch(err => err);

export default UserAchievementUsedAppFirstTime;
